module.exports = __webpack_public_path__ + "img/icv_logo.4c3508a7.png";